import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { useGetEmspUsersPaginatedFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/emsp-users/get-emsp-users-paginated.form-validation';
import { GetEmspUsersPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/emsp-users/get-emsp-users-paginated.model';
import { Controller, useFormContext } from 'react-hook-form';

import { EmspBoEmspUserBillingFrequencyFilterController } from '../../../emsp-bo-emsp-user-billing-frequency-filter/emsp-bo-emsp-user-billing-frequency-filter.controller';

const EmspUserListFilterFormStep1BillingFrequencyFragment =
  (): React.JSX.Element => {
    // CONTEXT /////////////////////////////////////////////////////////////////

    const { control } = useFormContext<GetEmspUsersPaginatedModel>();
    const { billingFrequency } = useGetEmspUsersPaginatedFormValidation();

    // RENDER //////////////////////////////////////////////////////////////////

    return (
      <Controller
        name="billingFrequency"
        control={control}
        rules={billingFrequency}
        render={({ field /* , fieldState: { error } */ }) => {
          const values: string[] = [];

          if (Array.isArray(field.value)) {
            values.push(...field.value);
          } else if (field.value) {
            values.push(field.value);
          }

          return (
            <EmspBoEmspUserBillingFrequencyFilterController
              selectedItemIds={values}
              onChange={(value) => field.onChange(value)}
            />
          );
        }}
      />
    );
  };

export const EmspUserListFilterFormStep1Controller = (): React.JSX.Element => {
  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack
      direction="row"
      justifyContent="stretch"
      alignItems="stretch"
      flex={1}
      gap={GapEnum.M}>
      <Stack direction="column" flex={1} alignItems="stretch" gap={GapEnum.M}>
        <EmspUserListFilterFormStep1BillingFrequencyFragment />
      </Stack>
    </Stack>
  );
};
